jQuery(document).ready(function ($) {
  "use strict";
  function sectionBannerX() {
    $(".section-banner-x").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 4,
      slidesToScroll: 2,
      arrows: false,
      dots: true,
      prevArrow:
        '<button class="testimonial-arrow arrow-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow:
        '<button class="testimonial-arrow arrow-next"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }
  function sectionBannerV12() {
    $(".section-banner-v12-carousel").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      prevArrow:
        '<button class="testimonial-arrow arrow-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow:
        '<button class="testimonial-arrow arrow-next"><i class="fa fa-angle-right"></i></button>',
    });
  }
  sectionBannerX();
  sectionBannerV12();
});
